import { Component } from '@angular/core';
import { UikitFormElementComponent } from './uikit-form-element.component';
@Component({
    selector: 'ecom-form-element-text',
    templateUrl: './ecom-form-element-text.component.html',
    standalone: false
})
export class EcomFormElementTextComponent extends UikitFormElementComponent {}
